<template>
<span>
    <v-toolbar flat color="white">
        <v-toolbar-title class="lime--text lighten-1">Gerenciar Marcas</v-toolbar-title>
        <v-divider class="mx-2" inset vertical></v-divider>
        <v-spacer></v-spacer>
        <template>
            <v-btn color="blue-grey darken-2" dark class="mb-1" @click.prevent="atualizaDados">
                <v-icon dark>sync</v-icon>Atualizar
            </v-btn>
            <v-btn color="success" dark class="mb-1 ml-2" :to="{name: 'product-brand.add'}">
                <v-icon class="mdi mdi-plus"></v-icon>Adicionar Nova Marca</v-btn>
        </template>
    </v-toolbar>

    <v-card>
        <v-card-title>
            <v-text-field v-model="search" append-icon="search" label="Localizar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table :headers="headers" :items="loadProductBrands" :search="search" :rowsPerPageItems="rowsPerPageItems">

            <template v-slot:[`item.prod_b_logo`]="{ item }">
                <td width="15%" v-if="item.prod_b_logo"><img :src="`${base_url}upload/product_brand/${item.prod_b_logo}?${uuid}`" class="avatar"></td>
                <td width="15%" v-if="!item.prod_b_logo"><img :src="`${base_url}upload/logo.png`" class="avatar"></td>
            </template>

             <template v-slot:[`item.prod_b_status`]="{ item }">
                <td>
                    <v-switch color="lime" v-model="item.prod_b_status" @change="onChangeEventHandlerStatus(item.prod_b_id, $event)" class="my-switch"></v-switch>
                </td>
            </template>

            <template v-slot:[`item.acoes`]="{ item }">
                <v-tooltip top color="blue white--text">
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="blue lighten-1" @click.prevent="editProductBrand(item)" v-on="on">
                            <v-icon dark>mdi-pencil</v-icon>
                        </v-btn>
                    </template>
                    <span>Editar</span>
                </v-tooltip>

                <v-tooltip top color="red white--text">
                    <template v-slot:activator="{ on }">
                        <v-btn icon color="red lighten-1" @click.prevent="deleteProductBrand(item)" v-on="on">
                            <v-icon dark class="mdi mdi-delete"></v-icon>
                        </v-btn>
                    </template>
                    <span>Excluir</span>
                </v-tooltip>

            </template>

            <template v-slot:no-results>
                <v-alert :value="true" color="error" icon="warning">Voce procurou por "{{ search }}" nenhum item localizado.</v-alert>
            </template>
        </v-data-table>
    </v-card>
</span>
</template>

<script>
import {
    uuid
} from "vue-uuid";
import {
    URL_BASE
} from "../../../config/configs";

export default {
    name: "ProductBrandComponent",
    created() {
        this.$store.dispatch("loadProductBrands");
    },
    computed: {
        loadProductBrands() {
            if (this.$store.state.productbrands.items.data == null) return [];

            return this.$store.state.productbrands.items.data;
        }
    },
    data() {
        return {
            search: "",
            rowsPerPageItems: [
                10,
                20,
                30,
                50,
                {
                    text: "$vuetify.dataIterator.rowsPerPageAll",
                    value: -1
                }
            ],
            headers: [{
                    text: "logo",
                    align: "left",
                    sortable: false,
                    value: "prod_b_logo"
                },
                {
                    sortable: false,
                    text: "Nome",
                    value: "prod_b_nome"
                },
                {
                    sortable: false,
                    text: "Descrição",
                    value: "prod_b_descricao"
                },
                {
                    sortable: false,
                    text: "Status",
                    value: "prod_b_status"
                },
                {
                    text: "Ações",
                    align: "center",
                    sortable: false,
                    value: "acoes"
                }
            ],
            productbrand: [],
            base_url: URL_BASE,
            uuid: uuid.v1()
        };
    },
    methods: {
        atualizaDados() {
            this.$store.dispatch("loadProductBrands");
        },
        editProductBrand(item) {
            this.$router.push({
                name: "product-brand.edit",
                params: {
                    prod_b_id: item.prod_b_id
                }
            });
        },
        detailProductBrand(item) {
            this.$router.push({
                name: "product-brand.detail",
                params: {
                    prod_b_id: item.prod_b_id
                }
            });
        },
        deleteProductBrand(item) {
            this.$swal({
                title: "Você tem certeza?",
                text: "Você não poderá reverter isso",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#D32F2F",
                cancelButtonColor: "#1976D2",
                confirmButtonText: "Sim, Exclua!"
            }).then(result => {
                if (result.value) {
                    this.$store
                        .dispatch("destroyProductBrand", item.prod_b_id)
                        .then(response => {
                            if (response) {
                                this.$swal({
                                    position: "center",
                                    icon: "success",
                                    title: "Sucesso",
                                    text: "Dados excluídos com sucesso",
                                    showConfirmButton: true,
                                    timer: 6000
                                });
                                this.atualizaDados();
                            } else {
                                this.$swal({
                                    position: "center",
                                    icon: "error",
                                    title: "Opssss!",
                                    text: "Erro ao excluir dados",
                                    showConfirmButton: true,
                                    timer: 6000
                                });
                            }
                        })
                        .catch(error => {
                            this.$swal({
                                position: "center",
                                icon: "error",
                                title: "Opssss!",
                                text: "Algo errado aconteceu!",
                                showConfirmButton: true,
                                timer: 6000
                            });
                        });
                }
            });
        },
        onChangeEventHandlerStatus(prod_b_id, value) {
            this.$store
                .dispatch("updateProductBrandStatus", {
                    prod_b_id: prod_b_id,
                    prod_b_status: value
                })
                .then(() => {
                    this.$swal({
                        position: "center",
                        icon: "success",
                        title: "Sucesso",
                        text: "Status do Status atualizado com sucesso",
                        showConfirmButton: true,
                        timer: 6000
                    });
                })
                .catch(error => {
                    this.$swal({
                        position: "center",
                        icon: "error",
                        title: "Opssss!",
                        text: "Erro ao atualizar status do Status",
                        showConfirmButton: true,
                        timer: 6000
                    });
                });
        }
    },
    components: {}
};
</script>

<style scoped>
.avatar {
    height: 40px;
    margin-top: 0.4rem;
}
</style>
